import React from 'react'
import BreadcrumbContainer from '../../../Components/BonusUi/Breadcrumb'

export default function Breadcrumb() {
    return (
        <div className='page-body'>
            <BreadcrumbContainer />
        </div>
    )
}
